export default function EndingSection() {
  const points = [
    {
      title: '伏笔大盘点',
      desc: '把散落在几十话里的关键线索串联起来，看看作者到底埋了多少机关。',
      icon: 'ri-map-pin-line',
    },
    {
      title: '三种结局推演',
      desc: '结合叙事节奏与已有证据，推演出最可能的几种走向并对比其合理性。',
      icon: 'ri-git-branch-line',
    },
    {
      title: '开放式 vs 既定结局',
      desc: '讨论开放式收尾是否成立，以及开放式写作的高级表达方式。',
      icon: 'ri-question-answer-line',
    },
  ];

  return (
    <section id="ending" className="relative scroll-mt-20 overflow-hidden bg-background-900 py-16 md:py-20">
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20comic%20ink%20wash%20texture%20background%2C%20deep%20charcoal%20with%20warm%20amber%20accents%2C%20subtle%20halftone%20dots%2C%20moody%20graphic%20novel%20style&width=1600&height=700&seq=ending-bg-heixiu-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover"
        />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-semibold text-foreground-950 whitespace-nowrap">
              <i className="ri-movie-line" />
              结局探讨
            </span>
            <h2 className="mt-5 font-heading text-3xl font-black text-background-50 md:text-4xl">
              结局真相，正在被一点点拼出来
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100/90">
              关于《嘿咻嘿咻漫画》的结局，社区里已经吵了很多个回合。本文站把所有主流观点、矛盾点与支撑证据集中在一起，理性推演结局真相。是开放式，还是藏着更大的反转？答案也许就藏在那些你忽略的角落。
            </p>
            <a
              href="#community"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-discuss-line" />
              参与结局讨论
            </a>
          </div>

          <div className="flex flex-col gap-4">
            {points.map((p, i) => (
              <div
                key={p.title}
                className="flex items-start gap-4 rounded-lg bg-background-950/50 p-5 ring-1 ring-background-800/60 backdrop-blur"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                  <i className={`${p.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-background-50">
                    <span className="mr-2 text-accent-400">0{i + 1}</span>
                    {p.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-background-200">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}